window.angular.module('hippo').directive('landingPageTopQuoteForm', function () {
    return {
        scope: {
            data: '<',
            onEvent: '&',
            dynamicCta: '@'
        },
        template: `
      <div ng-if="!showDynamicButton" class="cta col-sm-8 col-xs-4 col-lg-9 col-md-8 center-horizontally inverted-colors">
        <p class="mobile-address-input-title center-horizontally">{{mobileAddressInputTitle}}</p>
        <button class="get-instant-quote-button mh-button">{{ctaCopy}}</button>
        <form>
          <div class='input'>
            <mh-quote-form name="landing-address-page" button-text="{{ctaCopy}}" data="data" start-new-lead="onEvent({$event:$event})"></mh-quote-form>
          </div>
        </form>
      </div>
      <div ng-if="showDynamicButton" id="lazy-sticky-container">
        <a ng-click="returnToLanding()" class="logo" id="{{pages[activePage].key}}-logo-white">
          <img class="hippo-text-logo-green hippo-text-logo sticky-logo" src="/img/new-design/hippo-icon-hippotext-green.svg" />
        </a>
        <div class="cta col-sm-8 col-xs-4 col-lg-10 col-mg-9 center-horizontally inverted-colors">
          <p class="mobile-address-input-title center-horizontally">{{mobileAddressInputTitle}}</p>
          <button class="get-instant-quote-button mh-button">{{ctaCopy}}</button>
          <form>
            <div class='input'>
              <mh-quote-form name="landing-address-page" button-text="{{ctaCopy}}" data="data" start-new-lead="onEvent({$event:$event})"></mh-quote-form>
            </div>
          </form>
        </div>
      </div>
    `,
        controller: function ($scope, featureToggle, $window, $timeout) {
            'ngInject';
            const { $ } = window;
            $scope.ctaCopy = featureToggle.showNewCTATextOnLandingPage() ? 'Buy Online Now' : 'Quote in 60 seconds';
            const gridMediumBreakpoint = 768;
            const gridLargeBreakpoint = 840;
            const gridXLargeBreakpoint = 1024;
            const gridXXLargeBreakpoint = 1366;
            const newScrollAnimation = featureToggle.showNewDesign();

            const isAuxPage = $('body').attr('class').indexOf('aux-page') !== -1;
            const $page = $(isAuxPage ? document : newScrollAnimation ? document : '.page');
            $scope.showNewDesign = featureToggle.showNewDesign();
            $scope.showDynamicButton = $scope.showNewDesign && $scope.dynamicCta === 'true';
            $scope.mobileAddressInputTitle = $scope.showNewDesign
                ? "What's your home address?"
                : 'Enter your home address to get an instant quote in seconds';
            let expandEventFired = false;
            let isNavFixed = false;
            let $inputField;
            let $inputDropdown;

            $scope.returnToLanding = () => {
                if (window.scope.backToLanding) {
                    window.scope.handleDeepEvent({ eventType: 'backToLanding' });
                } else {
                    window.location.href = $scope.landingUrl;
                }
                window.scope.holdScrollWhileRendering(2500);
            };

            function setInputBorderRadius() {
                if ($inputDropdown.css('display') === 'none') {
                    $inputField.addClass('round-border');
                } else {
                    $inputField.removeClass('round-border');
                }
            }

            function handleDropdownChangeEvent() {
                setInputBorderRadius();
                let intervalCount = 0;
                const interval = setInterval(() => {
                    setInputBorderRadius();
                    if (intervalCount >= 80) {
                        clearInterval(interval);
                    }
                    intervalCount++;
                }, 30);
            }

            function setDropdownLocation($inputDropdown, $inputField) {
                const inputWidth = $inputField.outerWidth();
                const inputHeight = $inputField.height();
                const inputOffset = $inputField.offset();
                $inputDropdown.css({
                    width: `${inputWidth}px`,
                    left: `${inputOffset.left}px`,
                    top: `${inputOffset.top + inputHeight}px`
                });
            }

            function setButtonText(buttonText) {
                const $inputButton = $('.landing-button');
                $inputButton.text(buttonText);
            }

            function handleNewScroll() {
                const scrollTop = $page.scrollTop();
                const $lazyStickyContainer = $('#lazy-sticky-container');
                $inputDropdown = $('.pac-container').last();

                let ctaOffset;
                const windowWidth = $(document.body).width();
                if (isAuxPage) {
                    ctaOffset = 100;
                } else if (windowWidth >= gridXXLargeBreakpoint) {
                    ctaOffset = 480;
                } else if (windowWidth >= gridXLargeBreakpoint) {
                    ctaOffset = 460;
                } else if (windowWidth >= gridLargeBreakpoint) {
                    ctaOffset = 410;
                } else if (windowWidth >= gridMediumBreakpoint) {
                    ctaOffset = 290;
                }
                if (scrollTop >= ctaOffset && !isNavFixed) {
                    if (!expandEventFired) {
                        if (isAuxPage) {
                            $('landing-page-top-quote-form .cta').addClass('active');
                        }
                        $scope.$root.$broadcast('landing:openDesktopAddressInput');
                        expandEventFired = true;
                        $lazyStickyContainer.addClass('instant-animation');
                    }
                    $lazyStickyContainer.addClass('lazy-sticky-static');
                    $inputDropdown.addClass('fixed');
                    isNavFixed = true;
                    $inputDropdown.css({ display: 'none' });
                    $inputField.addClass('round-border');
                    setDropdownLocation($inputDropdown, $inputField);
                    setButtonText('Quote in 60 sec');
                    handleDropdownChangeEvent();
                } else if (scrollTop < ctaOffset && isNavFixed) {
                    $lazyStickyContainer.removeClass('lazy-sticky-static');
                    $inputDropdown.removeClass('fixed');
                    isNavFixed = false;
                    setDropdownLocation($inputDropdown, $inputField);
                    setButtonText('Quote in 60 seconds');
                }
            }

            function handleOldScroll() {
                const scrollTop = $page.scrollTop();
                if (window.innerWidth >= gridLargeBreakpoint) {
                    const $addressForm = $('landing-page-top-quote-form .cta');
                    const $body = $('body');
                    const $navList = $('.landing-nav');
                    const $navLogo = $('.nav-wrap .logo');
                    if (scrollTop >= 290) {
                        $addressForm.addClass('sticky');
                        $navLogo.addClass('active');
                        $body.addClass('nav-live-address');
                        $navList.addClass('animate-out');
                        $navList.removeClass('animate-in');
                    } else {
                        $navLogo.removeClass('active');
                        $addressForm.removeClass('sticky');
                        $body.removeClass('nav-live-address');
                        $navList.addClass('animate-in');
                        $navList.removeClass('animate-out');
                    }
                }
                if (window.innerWidth >= gridMediumBreakpoint) {
                    const $bottomQuote = $('button.sticky-get-instant-quote-button');
                    if (scrollTop >= 310) {
                        $bottomQuote.addClass('sticky-tablet');
                    } else {
                        $bottomQuote.removeClass('sticky-tablet');
                    }
                }
            }

            function onScroll() {
                if (newScrollAnimation) {
                    handleNewScroll();
                } else {
                    handleOldScroll();
                }
            }

            onScroll();
            $page.scroll(onScroll);
            $window.onload = onScroll;

            const waitForElements = () => {
                $inputField = $('.input-street');
                $inputDropdown = $('.pac-container').last();
                $inputField.keydown(handleDropdownChangeEvent);
                $inputField.click(handleDropdownChangeEvent);
                const loadedElements = $inputField.length + $inputDropdown.length;
                if (loadedElements < 2) {
                    $timeout(waitForElements, 50);
                }
            };
            $timeout(waitForElements, 0);
        }
    };
});
